import { computed, defineComponent, onBeforeUnmount, onMounted, PropType, ref, toRef, watch } from "vue";
import FilterOption from "../FilterOption/FilterOption.vue";
import { FacetList, facetValue } from "../../interfaces/Filter";
import { useStore } from 'vuex';
import Bean from "../Bean/Bean.vue";
import CloseArrowIcon from "../../assets/close-arrow-icon.vue";

export default defineComponent({
  name: 'FilterModal',
  components: {
    FilterOption,
    Bean,
    CloseArrowIcon
  },
  props: {
    facetList: {
      type: Array as PropType<FacetList[]>,
      required: true
    },
    totalFilterResult: {
      type: Number,
      required: true
    }
  },
  emits: ['close', 'apply-filters', 'reset-filters'], // Dichiarazione degli eventi emessi
  setup(props, { emit }) {
    // Dato reattivo per il modal e facetView
    const isModalOpen = ref<boolean>(true);
    // Usa useStore per accedere allo store di Vuex
    const store = useStore();
    const openIndex = ref(null);

    // Recupera il getter selectedFilters dallo store
    const appliedFilter = computed<facetValue[]>(() => store.getters.selectedFilters);

    const totalFilterResult = toRef(props, 'totalFilterResult');

    const updateOpenIndex = (index: null) => {
      // Se clicchi sull'accordion già aperto, chiudilo (null)
      openIndex.value = openIndex.value === index ? null : index;
    };

    watch(() => props.facetList, (newFacetList) => {
      console.log("FacetList aggiornata", newFacetList);
      // Puoi fare operazioni aggiuntive qui, se necessario
    }, { deep: true });

    const closeModal = () => {
      emit('close');
      isModalOpen.value = false;
    };

    const applyFilters = () => {
      emit('apply-filters');
    }

    const resetFilters = () => {
      if (store.getters.selectedFilters.length > 0) {
        emit('reset-filters');
      }
    }



    // Funzione per controllare lo scroll e applicare la classe sticky
    function handleStickyHeader() {
      const filterModalContent = document.querySelector('.filter-section');
      const brandHeader = document.querySelector('.accordion-header-brand');
      const allHeaders = document.querySelectorAll('.accordion-header');
      if (!filterModalContent || !brandHeader) return;

      filterModalContent.addEventListener('scroll', () => {
        const brandFilterIsOpen = document.querySelector('.search-bar');
        if (brandFilterIsOpen) {
          const rect = brandHeader.getBoundingClientRect();
          const modalRect = filterModalContent.getBoundingClientRect();

          if (rect.top <= modalRect.top) {
            brandHeader.classList.add('sticky');
          }

          allHeaders.forEach(header => {
            if (header !== brandHeader) {
              const headerRect = header.getBoundingClientRect();
              if (headerRect.top <= modalRect.top && headerRect.bottom >= modalRect.top) {
                brandHeader.classList.remove('sticky');
              }
            }
          });

        }
      });
    }

    onMounted(() => {
      handleStickyHeader();

      if (
        /iP(hone|od|ad)/.test(navigator.userAgent) &&
        /WebKit/.test(navigator.userAgent) &&
        !/CriOS/.test(navigator.userAgent)
      ) {
        document.documentElement.classList.add('is-ios-safari');
      }
    });

    onBeforeUnmount(() => {
      const filterModalContent = document.querySelector('.filter-section');
      filterModalContent?.removeEventListener('scroll', handleStickyHeader);
    });



    return {
      isModalOpen,
      facetList: props.facetList,
      closeModal,
      applyFilters,
      appliedFilter,
      totalFilterResult: totalFilterResult,
      updateOpenIndex,
      openIndex,
      resetFilters
    };
  },
});